const ourBusinessesInitState = {
    ourBusinessesData: {},
    medicinesData: {},
    tenderData: {},
    searchData: {},
    hereForYouData: {}
};

export default ourBusinessesInitState;
